/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_CAMPAIGNS_ITEM = {
  id: 'agro_cultivos_campaigns',
  screenId: 'agr-cul-campaigns',
  label: 'Campañas',
  description: 'Períodos de campaña agrícola (inicio, fin y descripción).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Una campaña es el período agrícola del año (por ejemplo 2025/26). Agrupa siembras anuales y también las temporadas de cosecha de plantaciones perennes (uva, frutales, etc.).',
      },
      {
        title: 'Paso 1 — Ver la lista',
        bullets: [
          'Columnas: Inicio, Fin, Descripción.',
          'Lápiz para editar; tachito para eliminar.',
          'El botón + abre el alta.',
          'Podés exportar la lista.',
        ],
      },
      {
        title: 'Paso 2 — Alta o edición',
        fields: [
          {
            label: 'Inicio',
            description: 'Fecha de comienzo de la campaña.',
          },
          {
            label: 'Fin',
            description: 'Fecha de cierre. Debe ser posterior al inicio.',
          },
          {
            label: 'Descripción',
            description: 'Nombre corto (ej. Campaña 2025/26 gruesa).',
          },
        ],
        paragraphs: ['Tocá «Guardar» para confirmar.'],
      },
      {
        title: 'Campañas y perennes',
        bullets: [
          'Los cultivos anuales se siembran dentro de una campaña.',
          'Los perennes se implantan una sola vez; cada año abrís una temporada ligada a una campaña desde el detalle de la plantación.',
        ],
      },
    ],
  },
}
